import React from 'react';
import { DataVizContainer } from '../common/DataVizContainer';
import {
  TimePeriodSegmentedVizConfig,
  TimePeriodSegmentedVizExternalProps,
  TimePeriodSegmentedVizViews,
} from './types';
import { useTimePeriodSegmentedConfigToData } from './useConfigToData';
import { timePeriodSegmentedViewConfigs } from './views/view-configs';

export interface TimePeriodSegmentedVizProps {
  dataConfig: TimePeriodSegmentedVizConfig;
  selectedView: TimePeriodSegmentedVizViews;
  externalProps: TimePeriodSegmentedVizExternalProps;
  persistenceKey: string;
}

export const TimePeriodSegmentedViz = (props: TimePeriodSegmentedVizProps) => {
  return (
    <DataVizContainer
      dataConfig={props.dataConfig}
      externalProps={props.externalProps}
      useConfigToData={useTimePeriodSegmentedConfigToData}
      selectedView={props.selectedView}
      viewConfigs={timePeriodSegmentedViewConfigs}
      persistenceKey={props.persistenceKey}
    />
  );
};
